<template>
  <div id="weixinLoginUser-edit">

    <IForm :label-width="130" ref="formInline" :model="edit" :elem="weixinLoginUserElem" :rules="weixinLoginUserRule" @on-submit="toSubmit" :submit="false" :showMessage="true">
      <div slot="extend">
        <Row>
          <Col span="24"><FormItem label="openid" prop="openid"><Input v-model.trim="edit.openid" type="text" placeholder="请输入openid" maxlength="50" :disabled="true"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="24"><FormItem label="unionid" prop="unionid"><Input v-model.trim="edit.unionid" type="text" placeholder="请输入unionid" maxlength="50" :disabled="true"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="24"><FormItem label="昵称" prop="nickname"><Input v-model.trim="edit.nickname" type="text" placeholder="请输入昵称" maxlength="20" :disabled="true"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="24"><FormItem label="手机号码" prop="mobile"><Input v-model.trim="edit.mobile" type="text" placeholder="请输入手机号码" maxlength="15"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="状态" prop="status">
              <Select v-model="edit.status">
                <Option v-for="item in statusList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="备注" prop="remark"><Input v-model="edit.remark" type="textarea" placeholder="请输入备注"/></FormItem>
          </Col>
        </Row>
      </div>
    </IForm>

  </div>
</template>
<script>
import { _get, _edit} from "@/services/manage/weixinLoginUser";
export default {
  name: "WeixinLoginUserEdit",
  data() {
    return {
      edit: {
        openid: "",
        ip: "",
        remarks: "",
        status: 1
      },
      init: "",
      statusList:[
        {label: '全部', value: ''},
        {label: '启用', value: 1},
        {label: '禁用', value: 2},
      ],
      weixinLoginUserElem: [],
      weixinLoginUserRule: {
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
            type:'number'
          }
        ]
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    handleModal(row) {
      this.$refs["formInline"].handleReset();
      this.handleEdit(row);
      this.$forceUpdate();
    },
    handleEdit(row) {
      _get({openid: row.openid}).then(res =>{
        row = res.data;
        this.edit = Object.assign({}, row);
        this.$forceUpdate();
      })
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      const payload = {
        ...this.edit,
      }
      _edit(payload).then(res => {
        if (res.errcode === 1) {
          this.$message.success("保存成功");
          this.$emit("on-submit", false);
        }else{
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    }
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-input__inner {height: 32px;line-height: 32px;}
/deep/ .el-input__icon{line-height: 32px;}
/deep/ .ivu-input[disabled], fieldset[disabled] .ivu-input {background-color: #f3f3f38c;color: #515a6e;}
</style>
